import axios from "api/axios";
import { urlParamsString } from "utils";
import assert from "utils/assert";

/**
 * @param {string} pageId
 * @param {?boolean} fresh If true, ignore cache and fetch fresh data
 * @returns {Promise<string>}
 */
export function apiGetKBPage(pageId, fresh = false) {
  assert(pageId);
  return axios.get(`/kb/${encodeURIComponent(pageId)}?fresh=${fresh}`).then(({ data }) => data);
}

/**
 * @param {?boolean} fresh If true, ignore cache and fetch fresh data
 * @returns {Promise} {id, title, icon, properties}
 */
export function apiGetKBPageMetadata(pageId, fresh = false) {
  assert(pageId);
  return axios.get(`/kb/metadata/${encodeURIComponent(pageId)}?fresh=${fresh}`).then(({ data }) => data);
}


export function getKBPageTitle(page) {
  let title = page.title; // Did our Java put it in a nice place?
  if (!title) {
    let titleProperty = page.properties?.title || page.properties?.Name;
    if (!titleProperty) {
      console.log("Cant find title property for page", page);
      return page.id;
    }
    title = titleProperty?.title?.map((b) => b.plain_text || b.text?.content).join(" ");
  }
  if (title) {
    // HACK chop leading /path/to/page/ -- Which we use to mark KB pages in Notion
    title = title.replace(/^ ?\/\S+/, "").trim();
    return title;
  }
  console.log("Cant find title for page", page);
  return page.id;
}

/**
 * @param {?boolean} fresh If true, ignore cache and fetch fresh data
 * @returns {Promise} [{id, title}]
 */
export function apiListKBPages(query, fresh = false) {
  // Note: unpack the cumbersome Notion API response to a simpler format
  return axios
    .get(`/kb/list?` + urlParamsString({ query, fresh }), {})
    .then(({ data }) => data.results.map(notionToSimpleFormat));
}

/**
 * Search KB pages by free-text query (no path-walking logic).
 * @param {string} query
 * @returns {Promise} [{id, title, icon, properties}]
 */
export function apiSearchKBPages(query) {
  return axios
    .get(`/kb/list?` + urlParamsString({ query }))
    .then(({ data }) => data.results.map(notionToSimpleFormat));
}

function notionToSimpleFormat(r) {
  let titleBit = r.properties?.title;
  let title = titleBit?.title?.map((b) => b.plain_text).join(" ");
  return { id: r.id, title, icon: r.icon, properties: r.properties };
}
